// API客户端 - 根据环境变量自动切换Mock或真实API
import mockApi from '../services/mock-api';
import realApi from '../services/api'; 

const useMock = import.meta.env.VITE_USE_MOCK === 'true'; // 只有明确设置为 true 时才使用 Mock

// 导出API服务
export const api = useMock ? mockApi : realApi; 

export default api;
